import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=5fa9e409&scoped=true"
import script from "./SettingsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&id=5fa9e409&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9e409",
  null
  
)

export default component.exports